import { type DropdownProps, type TablePaginationConfig } from 'antd';
import React from 'react';

import IconNext from '@/assets/icons/next.svg?react';
import IconPrev from '@/assets/icons/prev.svg?react';

const PAGE_SIZE = 20;
const MATERIAL_PAGE_SIZE = 5;
const IP_LABEL_BANNER_PAGE_SIZE = 18;
const IP_LABEL_ORGANIZATION_PAGE_SIZE = 10;

const COMMON_PAGINATION_OPTIONS: TablePaginationConfig = {
  hideOnSinglePage: true,
  nextIcon: React.createElement(IconNext),
  prevIcon: React.createElement(IconPrev),
};

const DEFAULT_PAGINATION_OPTIONS: TablePaginationConfig = {
  pageSize: PAGE_SIZE,
  ...COMMON_PAGINATION_OPTIONS,
};

const MATERIAL_PAGINATION_OPTIONS: TablePaginationConfig = {
  pageSize: MATERIAL_PAGE_SIZE,
  ...COMMON_PAGINATION_OPTIONS,
};

const IP_LABEL_BANNER_PAGINATION_OPTIONS: TablePaginationConfig = {
  pageSize: IP_LABEL_BANNER_PAGE_SIZE,
  ...COMMON_PAGINATION_OPTIONS,
};

const IP_LABEL_SHOP_LABEL_SETS_PAGINATION_OPTIONS: TablePaginationConfig = {
  pageSize: IP_LABEL_ORGANIZATION_PAGE_SIZE,
  ...COMMON_PAGINATION_OPTIONS,
};

const DEFAULT_DROPDOWN_OPTIONS: DropdownProps = {
  destroyPopupOnHide: true,
  trigger: ['click'],
  className: 'cursor-pointer',
  align: { offset: [-28, -36] },
};

export {
  DEFAULT_DROPDOWN_OPTIONS,
  DEFAULT_PAGINATION_OPTIONS,
  IP_LABEL_BANNER_PAGE_SIZE,
  IP_LABEL_BANNER_PAGINATION_OPTIONS,
  IP_LABEL_SHOP_LABEL_SETS_PAGINATION_OPTIONS,
  MATERIAL_PAGE_SIZE,
  MATERIAL_PAGINATION_OPTIONS,
  PAGE_SIZE,
};
